<h2 class="h3">{{ 'product.product_filters.heading' | translate }}</h2>

@if (filterNavigation()) {
<div class="row justify-content-left">
  @for (element of filterNavigation().filter; track trackByFn($index, element)) {
  <div class="filter-dropdown col-sm-6 col-md-3">
    <ish-filter-dropdown [filterElement]="element" (applyFilter)="applyFilter.emit($event)" />
  </div>
  }
</div>
}
